// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"281":"cabinet","594":"about"}[chunkId] + "." + {"281":"b635d22b","594":"ee33356a"}[chunkId] + ".js";
};